import Http from "@/services/http/core/http";

export default class HttpApiDrive extends Http {
  appSignature = "";
  baseURL = "";
  timeout = 20000;
  getConfig() {
    return {
      baseURL: this.baseURL,
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        'Content-Type': 'application/json',
        Accept: 'application/vnd.api.v1+json',
        'cora-auth': 'apidrive',
        'app-id': '1',
        'app-signature': this.getAppSignature()
      },
      proxy: false,
      timeout: this.timeout
    }
  }

  setConfig(baseURL, timeout) {
    this.baseURL = baseURL;
    this.timeout = timeout;
  }

  getAppSignature() {
    return this.appSignature;
  }

  setAppSignature(appSignature) {
    this.appSignature = appSignature;
  }

  use(Service) {
    return new Service(this);
  }
}
